import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import FafErrorDot from "./FafErrorDot";

// FAF field with the standard EOS error affordance: label turned red + info dot
// (FafErrorDot) opening an explanatory tooltip, instead of a separate red message.
// `invalid` triggers the error state; `errorMessage` (i18n key) customizes the
// tooltip, otherwise "Ce champ est obligatoire". Rendering the field itself (input/select/
// textarea/tags) stays carried by `children` to keep the faf styling.
// `errorLabel` titles the tooltip when the label needs values (ErrorPopup drops them).
const FafField = ({
  label,
  required,
  invalid,
  errorMessage,
  errorLabel,
  className,
  children,
}) => (
  <div
    className={`faf-field ${invalid ? "faf-field--error" : ""} ${
      className || ""
    }`}
  >
    <div className="faf-field-head">
      <span>
        <FormattedMessage {...label} />
        {required && " *"}
      </span>
      {/* Slot permanently reserved: the dot appears/disappears
          inside it without ever changing the header geometry (zero shift). */}
      <span className="faf-field-dot">
        {invalid && (
          <FafErrorDot
            label={errorLabel || label}
            errorMessage={errorMessage}
          />
        )}
      </span>
    </div>
    {children}
  </div>
);

FafField.propTypes = {
  label: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
    values: PropTypes.object,
  }).isRequired,
  required: PropTypes.bool,
  invalid: PropTypes.bool,
  errorMessage: PropTypes.string,
  errorLabel: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
  }),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FafField;
